// \src\pages\home\page.tsx

import Footer from "@/components/feature/Footer";
import Navbar from "@/components/feature/Navbar";
import HeroBanner from "@/pages/home/components/HeroBanner";
import RaffleBanner from "@/pages/home/components/RaffleBanner";
import BrandsCarousel from "@/pages/home/components/BrandsCarousel";
import Differentials from "@/pages/home/components/Differentials";
import FeaturedCategories from "@/pages/home/components/FeaturedCategories";
import PromoCarouselHome from "@/pages/home/components/PromoCarouselHome";
import AllProductsBanner from "@/pages/home/components/AllProductsBanner";
import Testimonials from "@/pages/home/components/Testimonials";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroBanner />
        <RaffleBanner />
        <BrandsCarousel />
        <PromoCarouselHome />
        <Differentials />
        <FeaturedCategories />
        <AllProductsBanner />
        <Testimonials />
      </main>
      <Footer />
    </>
  );
}